/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { shouldCheckOnVisible } from '@/helpers/swUpdate'

// PWA auto-update. Браузер сам проверяет новый service-worker только при
// навигации, которой в SPA не бывает — вкладки CRM живут днями и без
// принудительных проверок никогда не узнают о новом деплое. Поэтому:
//   1) registration.update() каждый час + при возврате фокуса на вкладку;
//   2) когда новый SW установлен и ждёт активации — кидаем 'swUpdated',
//      решение (тихий релоад / снекбар) принимает AppUpdateNotifier.

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000; // раз в час
const VISIBILITY_CHECK_MIN_GAP_MS = 10 * 60 * 1000; // не чаще раза в 10 минут по фокусу

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registered (registration) {
      let lastCheck = Date.now();
      const checkForUpdate = () => {
        lastCheck = Date.now();
        // update() кидает reject при оффлайне/сетевой ошибке — глушим, это не проблема
        registration.update().catch(() => {});
      };
      setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
      document.addEventListener('visibilitychange', () => {
        if (shouldCheckOnVisible({
          hidden: document.hidden,
          now: Date.now(),
          lastCheck,
          minGapMs: VISIBILITY_CHECK_MIN_GAP_MS,
        })) {
          checkForUpdate();
        }
      });
    },
    updated (registration) {
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
